import { List,Record } from "immutable";

import filterMatchOptions from "../../../../constants/filterMatchOptions";
import createFromJS from "../../../createFromJS";

export const ListFilterPartRecord = Record({
  terms: List(),
  match: filterMatchOptions.ANY
});

const data = {
  objects: {
    terms: "List"
  }
};
createFromJS.registerCallback("ListFilterPartRecord", createFromJS.createNestedCallback(ListFilterPartRecord, data));
